import { render, staticRenderFns } from "./VerificationSnapshots.vue?vue&type=template&id=10233ab4"
import script from "./VerificationSnapshots.vue?vue&type=script&lang=js"
export * from "./VerificationSnapshots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports